// Indirect eval ((0, eval)) parses the expression in global scope and avoids esbuild's direct-eval
// bundling warning; the wrapped expression does not reference any local scope.
export const evalHelper = (s) => ((0, eval)("(" + s + ")"));
